// Where to send someone after they sign in.
//
// RequireAuth and the invite screen both record the page the person was actually
// trying to reach before we interrupted them to sign in. Honoring it is what makes
// a drop notification work: tap the push while signed out, sign in, land on the
// drop instead of on league home.
//
// Pure and guarded on purpose. Only in-app paths are ever returned, so a value
// that somehow arrives from outside the app cannot bounce a signed-in session to
// another site, and we never loop a person back to the sign-in screen they just
// finished.
export function safeRedirect(from: unknown): string {
  if (typeof from !== "string") return "/";
  const path = from.trim();
  if (!path.startsWith("/")) return "/";
  // "//evil.com" and "/\evil.com" are protocol-relative URLs, not in-app paths.
  if (path.startsWith("//") || path.startsWith("/\\")) return "/";
  if (path.startsWith("/login")) return "/";
  return path;
}
